
if (typeof Function.prototype.bind === 'undefined') {
  Function.prototype.bind = function (context) {
    var params = ([]).slice.call(arguments, 1);
    var fn = this;
    return function () {
      var allParams = params.concat(([]).slice.call(arguments, 0));
      return fn.apply(context, allParams);
    };
  };
};
module.exports = function anonymous(locals, escape, include, rethrow
/*``*/) {
escape = escape || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  if(data){ 
    ; __append("\n<div class=\"match-ht team\">\n    <div class=\"ht-name name\">")
    ; __append(escape(data.hn))
    ; __append("</div>\n    <div class=\"ht-logo logo\">\n        <img src=\"")
    ; __append(escape(data.ha))
    ; __append("\" />\n    </div>\n</div>\n<div class=\"match-score\">\n    ")
    ; __append(escape(data.hs))
    ; __append("\n    <span class=\"score-split\">:</span>")
    ; __append(escape(data.vs))
    ; __append("\n</div>\n<div class=\"match-vt team\">\n    <div class=\"vt-logo logo\">\n        <img src=\"")
    ; __append(escape(data.va))
    ; __append("\" />\n    </div>\n    <div class=\"vt-name name\">")
    ; __append(escape(data.vn))
    ; __append("</div>\n\n</div>\n")
    ;  } 
    ; __append("\n")
  }
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/modules/sportMatch/matchInfo.ejs
// module id = 303
// module chunks = 0